/*! bal-related-reading — matches Hydrogen RelatedArticles / blog-card-helpers */
/* BC The Loop draft 2026-10-09 (final pass, C19): the two CATEGORY_HOOKS values no longer name CFU (same wording as snippets/article-card and article-related-reading), and the two \u escapes are written as String.fromCharCode so the file survives the inline upload. Live MD5 before edit 00f2767e. See theme-build/SYNC_OVERRIDES.md. */
(function () {
  var NEW_ARTICLE_DAYS = 30;
  var RELATED_SAME_CATEGORY_CAP = 1;
  var RELATED_READING_LANE_COUNT = 3;
  var RELATED_READING_POOL_COUNT = 9;
  var CATEGORY_HOOKS = {"Vaginal Microbiome Health":"5 strains · microbiome science · written for clarity","BV & Infections":"Evidence-based","Women's Probiotic Guide":"Strain transparency · label reading · how to choose","UTI & Urinary Health":"Cranberry + D-mannose context · prevention habits","Antibiotics & Recovery":"Post-antibiotic timing · recovery protocols"};
  var SLUG_HOOKS = {"best-vaginal-probiotics-2026":"How to choose · strain criteria · evidence guide","probiotics-for-bv":"BV research · strain selection · adjunct care","vaginal-microbiome-101":"CST types · life stages · ecosystem basics"};
  var SITE_DEFAULT = 'https://balancecomplex.com';

  function seededShuffle(items, seed) {
    var copy = items.slice();
    var hash = 0;
    for (var i = 0; i < seed.length; i++) {
      hash = (hash << 5) - hash + seed.charCodeAt(i);
      hash |= 0;
    }
    for (var i = copy.length - 1; i > 0; i--) {
      hash = (hash * 1103515245 + 12345) & 0x7fffffff;
      var j = Math.floor((hash / 2147483648) * (i + 1)); // FIX 9: high bits (see SHUFFLE BIAS)
      var tmp = copy[i];
      copy[i] = copy[j];
      copy[j] = tmp;
    }
    return copy;
  }

  function sanitizeCardExcerpt(raw) {
    var out = String(raw || '');
    out = out.replace(/^\s*#+\s*/, '');
    out = out.replace(/\*?\[Figure pending[^\]]*\]\*?/gi, ' ');
    out = out.replace(/^\s*\*?(?:Updated|Medically reviewed)[^\*\n]*\*?\s*/i, '');
    out = out.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '$1');
    out = out.replace(/\*+/g, '');
    out = out.replace(/\s*-{2,}\s*$/g, '');
    out = out.replace(new RegExp('\\s*' + String.fromCharCode(8212) + '\\s*', 'g'), ', ');
    out = out.replace(/\s+/g, ' ').trim();
    return out;
  }

  function truncateSafe(text, max) {
    max = max || 80;
    var s = String(text || '').trim();
    if (s.length <= max) return s;
    var slice = s.slice(0, max);
    var sp = slice.lastIndexOf(' ');
    var cut = sp > Math.floor(max * 0.5) ? slice.slice(0, sp) : slice;
    return cut.replace(/[.,;:]\s*$/, '') + String.fromCharCode(8230);
  }

  /**
   * Read time is DATA now (catalog `readMinutes`, derived from content_pieces.word_count
   * at 215 wpm). The old estimateReadMinutes() hashed the SLUG and clamped to
   * [6, 14] — it never read a word count. A card renders no read-time span at all rather
   * than print a fabricated number.
   */
  function readMinutesOf(article) {
    var m = Number(article && article.readMinutes);
    return isFinite(m) && m > 0 ? Math.floor(m) : 0;
  }

  function getCardHook(article) {
    return (
      SLUG_HOOKS[article.slug] ||
      (article.category && CATEGORY_HOOKS[article.category]) ||
      'Science-backed · written for clarity'
    );
  }

  function getArticleBadge(article) {
    var published = new Date(article.publishedAt);
    var now = Date.now();
    var daysSincePublish = (now - published.getTime()) / (1000 * 60 * 60 * 24);
    // Founder ruling 2026-09-29: articles show the publish date only, so no "Updated" badge.
    if (daysSincePublish <= NEW_ARTICLE_DAYS) return 'new';
    return null;
  }

  function formatArticleDate(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'UTC',
    });
  }

  function pickRelatedArticleSlugs(FILE_ARTICLES, opts) {
    var count = opts.count || 3;
    var excluded = {};
    if (opts.excludeSlug) excluded[opts.excludeSlug] = true;
    var current = opts.excludeSlug
      ? FILE_ARTICLES.find(function (a) { return a.slug === opts.excludeSlug; })
      : null;
    var currentCategory = current && current.category;
    var pool = FILE_ARTICLES.filter(function (a) { return !excluded[a.slug]; });
    var dailySeed =
      opts.shuffleSeed ||
      (opts.excludeSlug || 'blog') + '-' + new Date().toISOString().slice(0, 10);

    var picked = [];
    var seen = {};
    var perCategory = {};

    function add(slug) {
      if (seen[slug] || excluded[slug]) return false;
      var article = FILE_ARTICLES.find(function (e) { return e.slug === slug; });
      var category = (article && article.category) || 'uncategorized';
      var cap = category === currentCategory ? RELATED_SAME_CATEGORY_CAP : 2;
      var used = perCategory[category] || 0;
      if (used >= cap) return false;
      seen[slug] = true;
      picked.push(slug);
      perCategory[category] = used + 1;
      return true;
    }

    (opts.prioritySlugs || []).forEach(function (slug) {
      if (picked.length < count) add(slug);
    });

    var byCategory = {};
    pool.forEach(function (article) {
      if (seen[article.slug]) return;
      var category = article.category || 'uncategorized';
      if (!byCategory[category]) byCategory[category] = [];
      byCategory[category].push(article);
    });

    var categories = seededShuffle(Object.keys(byCategory), dailySeed + '-categories');
    var otherCategories = categories.filter(function (c) { return c !== currentCategory; });
    var pickOrder = currentCategory
      ? otherCategories.concat([currentCategory])
      : categories;

    var round = 0;
    while (picked.length < count && round < 4) {
      for (var ci = 0; ci < pickOrder.length; ci++) {
        if (picked.length >= count) break;
        var category = pickOrder[ci];
        var cap = category === currentCategory ? RELATED_SAME_CATEGORY_CAP : 2;
        if ((perCategory[category] || 0) >= cap) continue;
        var candidates = seededShuffle(
          byCategory[category] || [],
          dailySeed + '-' + category + '-' + round,
        );
        var next = candidates.find(function (a) { return !seen[a.slug]; });
        if (next) add(next.slug);
      }
      round++;
    }
    return seededShuffle(picked.slice(0, count), dailySeed);
  }

  function splitRelatedArticleLanes(slugs, laneCount) {
    laneCount = laneCount || RELATED_READING_LANE_COUNT;
    var lanes = [];
    for (var i = 0; i < laneCount; i++) lanes.push([]);
    slugs.forEach(function (slug) {
      var shortest = 0;
      for (var i = 1; i < lanes.length; i++) {
        if (lanes[i].length < lanes[shortest].length) shortest = i;
      }
      lanes[shortest].push(slug);
    });
    return lanes.filter(function (l) { return l.length > 0; });
  }

  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function cardHtml(article, site) {
    var badge = getArticleBadge(article);
    var hook = getCardHook(article);
    var mins = readMinutesOf(article);
    var date = formatArticleDate(article.publishedAt);
    var badgeHtml = badge
      ? '<span class="article-card-badge article-card-badge--' +
        badge +
        '">' +
        (badge === 'updated' ? 'Updated' : 'New') +
        '</span>'
      : '';
    var catHtml = article.category
      ? '<span class="article-category">' + esc(article.category) + '</span>'
      : '';
    var minsHtml = mins
      ? '<span class="article-card-byline__sep" aria-hidden="true">·</span><span>' +
        mins +
        ' min read</span>'
      : '';
    return (
      '<a class="related-reading__card" href="' +
      (site || SITE_DEFAULT) +
      '/blog/' +
      esc(article.slug) +
      '"><div class="article-card-content">' +
      badgeHtml +
      catHtml +
      '<h4 class="related-reading__title">' +
      esc(article.title) +
      '</h4>' +
      '<span class="article-card-hook">' +
      esc(hook) +
      '</span>' +
      '<p class="article-card-byline"><time datetime="' +
      esc(article.publishedAt) +
      '">' +
      esc(date) +
      '</time>' +
      minsHtml +
      '</p>' +
      '<span class="article-card-cta v4-link-arrow">Read article <span aria-hidden="true">→</span></span>' +
      '</div></a>'
    );
  }

  function applyLane(laneEl, active) {
    var items = laneEl.querySelectorAll('.related-reading__deck-item');
    var dots = laneEl.querySelectorAll('.related-reading__deck-dot');
    var total = items.length;
    items.forEach(function (item, i) {
      var stack = (i - active + total) % total;
      item.setAttribute('data-stack', String(stack));
      item.setAttribute('aria-hidden', stack === 0 ? 'false' : 'true');
    });
    dots.forEach(function (dot, i) {
      dot.setAttribute('aria-selected', i === active ? 'true' : 'false');
    });
  }

  function mount(root, FILE_ARTICLES) {
    var exclude = root.getAttribute('data-exclude-slug') || '';
    var site = root.getAttribute('data-site') || SITE_DEFAULT;
    // Same seed the Liquid map was built with, so the client re-derives the SET and
    // ORDER the server already rendered. Without it the picker fell back to a
    // per-CALENDAR-DAY seed and the hydrated deck disagreed with the server HTML.
    var poolSlugs = pickRelatedArticleSlugs(FILE_ARTICLES, {
      excludeSlug: exclude,
      count: RELATED_READING_POOL_COUNT,
      shuffleSeed: root.getAttribute('data-shuffle-seed') || undefined,
    });
    var lanes = splitRelatedArticleLanes(poolSlugs, RELATED_READING_LANE_COUNT);
    var html = '<h3>Related Reading</h3><div class="related-reading__lanes">';
    lanes.forEach(function (laneSlugs, laneIndex) {
      html +=
        '<div class="related-reading__lane" data-lane="' +
        laneIndex +
        '"><ul class="related-reading__deck" aria-live="polite" aria-label="Related articles deck ' +
        (laneIndex + 1) +
        '">';
      laneSlugs.forEach(function (slug, stackI) {
        var article = FILE_ARTICLES.find(function (a) { return a.slug === slug; });
        if (!article) return;
        html +=
          '<li class="related-reading__deck-item" data-stack="' +
          stackI +
          '" aria-hidden="' +
          (stackI === 0 ? 'false' : 'true') +
          '">' +
          cardHtml(article, site) +
          '</li>';
      });
      html += '</ul>';
      if (laneSlugs.length > 1) {
        html +=
          '<div class="related-reading__deck-dots" role="tablist" aria-label="Related articles deck ' +
          (laneIndex + 1) +
          ' position">';
        laneSlugs.forEach(function (_s, d) {
          html +=
            '<button type="button" role="tab" class="related-reading__deck-dot" aria-selected="' +
            (d === 0 ? 'true' : 'false') +
            '" aria-label="Show article ' +
            (d + 1) +
            ' of ' +
            laneSlugs.length +
            '" data-deck-dot="' +
            d +
            '"></button>';
        });
        html += '</div>';
      }
      html += '</div>';
    });
    html += '</div>';
    root.innerHTML = html;
    root.setAttribute('data-bal-related-ready', '1');

    var laneEls = root.querySelectorAll('.related-reading__lane');
    var indices = Array.prototype.map.call(laneEls, function () { return 0; });
    var nextLane = 0;
    var paused = false;
    laneEls.forEach(function (laneEl, laneIndex) {
      applyLane(laneEl, 0);
      laneEl.querySelectorAll('.related-reading__deck-dot').forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = Number(dot.getAttribute('data-deck-dot') || 0);
          indices[laneIndex] = i;
          applyLane(laneEl, i);
          nextLane = laneIndex;
        });
      });
    });
    var lanesWrap = root.querySelector('.related-reading__lanes');
    if (lanesWrap) {
      lanesWrap.addEventListener('mouseenter', function () { paused = true; });
      lanesWrap.addEventListener('mouseleave', function () { paused = false; });
    }
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    setInterval(function () {
      if (paused || !laneEls.length) return;
      var laneIndex = nextLane % laneEls.length;
      var laneEl = laneEls[laneIndex];
      var total = laneEl.querySelectorAll('.related-reading__deck-item').length;
      if (total > 1) {
        indices[laneIndex] = (indices[laneIndex] + 1) % total;
        applyLane(laneEl, indices[laneIndex]);
      }
      nextLane = (nextLane + 1) % laneEls.length;
    }, 7000);
  }

  /**
   * PROGRESSIVE ENHANCEMENT (THM-04). The section arrives from Liquid already
   * containing the real, crawlable <a href> cards — see snippets/bal-related-map.liquid.
   * mount() only ever REPLACES that markup with the interactive deck once the catalog
   * has actually loaded. Every early return and the .catch() therefore leave the
   * server-rendered list standing, which is the correct degraded state: before this,
   * a failed fetch left the reader looking at "Loading related articles…" forever.
   */
  function boot() {
    var root = document.querySelector('[data-bal-related-reading]');
    if (!root) return;
    var catalogUrl = root.getAttribute('data-catalog-url');
    if (!catalogUrl) return;
    fetch(catalogUrl, {credentials: 'same-origin'})
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var articles = (data && data.articles) || [];
        if (!articles.length) return;
        mount(root, articles);
      })
      .catch(function () { /* keep the server-rendered list */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Expose sanitize for any other card surfaces that need it
  window.balSanitizeCardExcerpt = sanitizeCardExcerpt;
  window.balTruncateSafe = truncateSafe;
})();